// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

.progress {
   height: 3px;
   margin-top: 1em;
   opacity: 0;
}

.visible {
   opacity: 1
}

::ng-deep .mat-button-focus-overlay {
   background-color: transparent !important;
}


.progress {
   height: 3px;
   margin-top: 1em;
   opacity: 0;
}

.visible {
   opacity: 1
}

::ng-deep .mat-button-focus-overlay {
   background-color: transparent !important;
}


.progress {
   height: 3px;
   margin-top: 1em;
   opacity: 0;
}

.visible {
   opacity: 1
}

::ng-deep .mat-button-focus-overlay {
   background-color: transparent !important;
}

`, "",{"version":3,"sources":["webpack://./src/app/e-signature/delete-dialog/delete-dialog.component.css"],"names":[],"mappings":";AACA;GACG,wBAAwB;AAC3B;;AAEA;GACG,WAAW;GACX,eAAe;GACf,UAAU;AACb;;AAEA;GACG;AACH;;AAEA;GACG,wCAAwC;AAC3C;;;AAGA;GACG,WAAW;GACX,eAAe;GACf,UAAU;AACb;;AAEA;GACG;AACH;;AAEA;GACG,wCAAwC;AAC3C;;;AAGA;GACG,WAAW;GACX,eAAe;GACf,UAAU;AACb;;AAEA;GACG;AACH;;AAEA;GACG,wCAAwC;AAC3C","sourcesContent":["\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n.progress {\n   height: 3px;\n   margin-top: 1em;\n   opacity: 0;\n}\n\n.visible {\n   opacity: 1\n}\n\n::ng-deep .mat-button-focus-overlay {\n   background-color: transparent !important;\n}\n\n\n.progress {\n   height: 3px;\n   margin-top: 1em;\n   opacity: 0;\n}\n\n.visible {\n   opacity: 1\n}\n\n::ng-deep .mat-button-focus-overlay {\n   background-color: transparent !important;\n}\n\n\n.progress {\n   height: 3px;\n   margin-top: 1em;\n   opacity: 0;\n}\n\n.visible {\n   opacity: 1\n}\n\n::ng-deep .mat-button-focus-overlay {\n   background-color: transparent !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
